import React, { useState } from "react";
import "./nav.css";
import { deepOrange } from "@mui/material/colors";
import Avatar from "@mui/material/Avatar";
import { FaHamsa } from "react-icons/fa";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [navScrolled, setNavScrolled] = useState(false);
  const [overlayOpen, setOverlayOpen] = useState(false);

  const toggleVisible = () => {
    if (window.scrollY > 0) {
      setNavScrolled(true);
    } else {
      setNavScrolled(false);
    }
  };

  window.addEventListener("scroll", toggleVisible);

  return (
    <>
      <header className={navScrolled && "scrolled"}>
        <div class="navbar">
          <Link to="/">
            <h1 class="textLogo">
              <span className={navScrolled && "scrolledTextLogo"}>
                Transcripter
              </span>
            </h1>
          </Link>
          <nav>
            <ul>
              <li>
                <Link to="/aboutus">
                  <a class={`asas ${navScrolled && "scrolledLink"}`} href="">
                    About Us
                  </a>
                </Link>
              </li>
              <li>
                <a class={`asas ${navScrolled && "scrolledLink"}`} href="">
                  How To use?
                </a>
              </li>
              {/* <li>
                <a class={`asas ${navScrolled && "scrolledLink"}`} href="">
                  Films
                </a>
              </li>
              <li>
                <a class={`asas ${navScrolled && "scrolledLink"}`} href="">
                  Journal
                </a>
              </li> */}
            </ul>
          </nav>
          <section className="profileeee">
            <div
              className={`hamburger ${navScrolled && "scrolledHamburger"}`}
              onClick={() => setOverlayOpen(!overlayOpen)}
            >
              <FaHamsa />
            </div>

            <div class="profileAvatarrr">
              <Avatar
                sx={{ bgcolor: deepOrange[500], width: 50, height: 50 }}
                alt="Remy Sharp"
                src="https://images.unsplash.com/photo-1610216705422-caa3fcb6d158?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80"
              />
            </div>
          </section>
        </div>
      </header>
      {overlayOpen && (
        <div className="navbarOverlay">
          <nav>
            <ul>
              <li>
                <a class={`asas ${navScrolled && "scrolledLink"}`} href="">
                  About Us
                </a>
              </li>
              <li>
                <a class={`asas ${navScrolled && "scrolledLink"}`} href="">
                  Instructors
                </a>
              </li>
              <li>
                <a class={`asas ${navScrolled && "scrolledLink"}`} href="">
                  Films
                </a>
              </li>
              <li>
                <a class={`asas ${navScrolled && "scrolledLink"}`} href="">
                  Journal
                </a>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </>
  );
};

export default Navbar;
